import { render } from "./TasksMaintenanceListView.vue?vue&type=template&id=24c3c2f6"
import script from "./TasksMaintenanceListView.vue?vue&type=script&lang=js"
export * from "./TasksMaintenanceListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__